import { CustomWindow } from "../custom"

declare let window: CustomWindow

export const SELECTED_CHANNEL_SLUG = "channel-usd"
export const CATEGORY_ACCESSORIES_SLUG = "accessories"
export const CATEGORY_TERMINALS_SLUG = "terminals"
export const PRODUCT_KU_WARRANTY_SLUG = "1-year-warranty-included"
export const PRODUCT_FLEXMOVE_TOPUP_SLUG = "topup-1gb"
export const PRODUCT_FLEXMOVE_DATAPLAN_SLUG = "intelsat-flexmove"
export const PRODUCT_RENTAL_DATA_PLAN_QUARTERLY_SLUG = "rental-data-plans-quarterly"
export const PRODUCT_RENTAL_DATA_PLAN_HALF_YEAR_SLUG = "rental-data-plans-half-year"
export const PRODUCT_RENTAL_TERMINAL_SLUG = "rental-ku"
export const RENTAL_INITIAL_COST_SLUG = "initial-cost"
export const RENTAL_MONTHLY_COST_SLUG = "monthly-rate"
export const DATA_PLANS_CATEGORY = "Data plans"
export const MODEM_SLUGS = ["iq200", "newtec-mdm2510", "uhp-210"]
export const IQ200_MODEM_SLUG = "iq200"
export const STRIPE_PLUGIN_GATEWAY = "saleor.payments.stripe"
export const STRIPE_APP_GATEWAY = "app.saleor.stripe"
export const IS_USING_STRIPE_PLUGIN_GATEWAY = window.env.REACT_APP_SALEOR_PAYMENT_GATEWAY === STRIPE_PLUGIN_GATEWAY
